import { useState } from "react";
import { Upload, EyeOff, Eye, Plus, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { MachineArt, card, inp, ghostBtn, greenBtn, uploadLaser } from "@/components/laser/LaserParts";

const Row = ({ c, onChange }) => {
  const [name, setName] = useState(c.name);
  const act = async (fn, ok) => { try { await fn(); toast.success(ok); onChange(); } catch (e) { toast.error(e.message); } };
  return (
    <div data-testid={`admin-catalog-${c.id}`} style={{ ...card, padding: 12, opacity: c.active === false ? 0.5 : 1 }}>
      <MachineArt item={c} h={130} />
      <input data-testid={`admin-catalog-name-${c.id}`} style={{ ...inp, marginTop: 8, padding: "7px 10px" }} value={name} onChange={(e) => setName(e.target.value)}
        onBlur={() => name !== c.name && act(() => api(`/laser/catalog/${c.id}`, { method: "PATCH", body: { name } }), "Renamed")} />
      <p className="mt-1 text-[11px] text-neutral-400">{c.watts}W {c.laser_type}</p>
      <div className="mt-2 flex gap-2">
        <label style={{ ...ghostBtn, cursor: "pointer" }} className="flex items-center gap-1" data-testid={`admin-catalog-image-${c.id}`}><Upload size={13} />Image
          <input type="file" accept="image/jpeg,image/png,image/webp" className="hidden" onChange={(e) => e.target.files[0] && act(() => uploadLaser(`catalog/${c.id}/image`, e.target.files[0]), "Image updated")} />
        </label>
        <button style={ghostBtn} className="flex items-center gap-1" data-testid={`admin-catalog-toggle-${c.id}`} onClick={() => act(() => api(`/laser/catalog/${c.id}`, { method: "PATCH", body: { active: c.active === false } }), c.active === false ? "Shown" : "Hidden")}>
          {c.active === false ? <Eye size={13} /> : <EyeOff size={13} />}{c.active === false ? "Show" : "Hide"}
        </button>
        {c.id.startsWith("custom-") && <button style={ghostBtn} aria-label="Delete model" data-testid={`admin-catalog-delete-${c.id}`} onClick={() => window.confirm(`Delete ${c.name}?`) && act(() => api(`/laser/catalog/${c.id}`, { method: "DELETE" }), "Deleted")}><Trash2 size={13} /></button>}
      </div>
    </div>
  );
};

export default function AdminCatalog({ catalog, onChange }) {
  const [f, setF] = useState({ name: "", watts: "" });
  const add = async () => {
    if (f.name.trim().length < 2 || !Number(f.watts)) return toast.error("Enter a name and wattage.");
    try { await api("/laser/catalog", { method: "POST", body: { name: f.name.trim(), watts: Number(f.watts) } }); setF({ name: "", watts: "" }); toast.success("Machine added to the ALR list"); onChange(); } catch (e) { toast.error(e.message); }
  };
  return (
    <section data-testid="admin-catalog" className="flex flex-col gap-3">
      <p style={{ color: "#4CCC06", fontSize: 11, fontWeight: 800, letterSpacing: 1.5 }}>ALR MACHINE LIST (ADMIN)</p>
      <div className="grid grid-cols-2 gap-3 md:grid-cols-3">{catalog.map((c) => <Row key={`${c.id}-${c.image_ver || ""}-${c.active}`} c={c} onChange={onChange} />)}</div>
      <div className="flex flex-wrap gap-2">
        <input data-testid="admin-catalog-new-name" style={{ ...inp, flex: 1, minWidth: 160 }} placeholder="New machine name" value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} />
        <input data-testid="admin-catalog-new-watts" type="number" style={{ ...inp, width: 120 }} placeholder="Watts" value={f.watts} onChange={(e) => setF({ ...f, watts: e.target.value })} />
        <button data-testid="admin-catalog-add" onClick={add} style={greenBtn} className="flex items-center gap-1"><Plus size={15} />Add</button>
      </div>
    </section>
  );
}
